import { gsap } from "gsap";
// import { TextPlugin } from "gsap/TextPlugin";


export default function() {
	// gsap.registerPlugin(TextPlugin);
	const homeHeroSection = document.getElementById('home-hero');
	const homeHeroTitle = homeHeroSection?.querySelector('#hero-title');
	if (!homeHeroTitle || !homeHeroSection) {
		return;
	}
	// const homeHeroSpans = homeHeroTitle.querySelectorAll('span');
	const homeHeroImageContainer = homeHeroSection.querySelector('.home-hero__background');
	const homeHeroImages = homeHeroImageContainer?.querySelectorAll('img');
	// preload images
	if (!homeHeroImages) {
		return;
	}
	// console.log('homeHeroImages', homeHeroImages);
	if(homeHeroImages) {
		// let textArray1 = homeHeroSpans[0].dataset.text?.split(',')
		// console.log('textArray1', textArray1);
		// let textArray2 = homeHeroSpans[1].dataset.text?.split(',')
		// console.log('textArray2', textArray2);
		// fade out the text, change the text, fade in the text
		// if (textArray1) {
		// 	let i = 1;
		// 	setInterval(() => {
		// 		gsap.fromTo(
		// 			homeHeroSpans[0],
		// 			{
		// 				opacity: 0.5,
		// 			},
		// 			{
		// 				duration: 0.3,
		// 				opacity: 1,
		// 				text: {
		// 					value: textArray1[i],
		// 					padSpace: true,
		// 					type: 'chars',
		// 				},
		// 			},
		// 		);
		// 		i++;
		// 		if (i >= textArray1.length) {
		// 			i = 0;
		// 		}
		// 	}, 2000);
		// }
		// if (textArray2) {
		// 	let i = 1;
		// 	setInterval(() => {
		// 		gsap.fromTo(
		// 			homeHeroSpans[1],
		// 			{
		// 				opacity: 0.5,
		// 			},
		// 			{
		// 				duration: 0.3,
		// 				opacity: 1,
		// 				text: {
		// 					value: textArray2[i],
		// 					type: 'chars',
		// 				},
		// 			},
		// 		);
		// 		i++;
		// 		if (i >= textArray2.length) {
		// 			i = 0;
		// 		}
		// 	}, 2000);
		// }
		if (homeHeroImages) {
			let tl = gsap.timeline();
			for (let i = 0; i < homeHeroImages.length; i++) {
				tl.fromTo(
					homeHeroImages[i],
					{
						opacity: 0,
					},
					{
						opacity: 1,
						duration: 1,
					},
				);
				tl.fromTo(
					homeHeroImages[i],
					{
						scale: 1,
					},
					{
						scale: 1.2,
						duration: 3,
					},
					"<",
				);
			}
			tl.repeat(-1);
			tl.duration(20);
		}
	}
}